// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"24":"reset","535":"login","881":"password"}[chunkId] + "." + {"24":"55a1a750","535":"49e4e5a5","881":"b81c33e7"}[chunkId] + ".js";
};